module.exports = "<app-issue-received *ngIf=\"actionName\" [actionFor]=\"actionId\" [getActionName]=\"actionName\"></app-issue-received>"